import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { MessageBanner } from '@nhl/nhl-react-ui/lib/MessageBanner';

import { FieldDefaultData, State } from '~/core/types';
import { leadersActions } from '~/redux/ducks/leaders';
import Analytics from '~/utility/analytics';
import { FilterState } from '~/views/pages/home/types';

import { Filter, LeaderContainer } from './components';
import utils from './utils';

import { HomeContainer } from './styles';

const HOME_TITLE = 'home';

const getFilterState = (fieldDefaultData?: FieldDefaultData): FilterState => {
    const stateFromQueryParams = utils.getStateFromQueryParams(window.location.search);

    return {
        seasonId: stateFromQueryParams.seasonId || fieldDefaultData?.seasonId,
        seasonIdForDisplay: stateFromQueryParams.seasonId || fieldDefaultData?.seasonId,
        gameTypeId: stateFromQueryParams.gameTypeId || fieldDefaultData?.gameTypeId,
        franchiseId: stateFromQueryParams.franchiseId || 0,
    };
};

// NOTE The state here is all local since the component tree is simple
const Home = () => {
    const dispatch = useDispatch();
    const statsConfig = useSelector((state: State) => state.config);

    const [filterState, setFilterState] = useState(getFilterState(statsConfig.fieldDefaultData));
    const [oldFilterState, setOldFilterState] = useState(getFilterState(statsConfig.fieldDefaultData));

    useEffect(() => {
        dispatch(leadersActions.requestLeaders(filterState));
    }, []);

    const sendGaEvent = (action) => {
        const { franchiseData } = statsConfig;
        Analytics.sendGaHomeEvent(action, filterState, franchiseData);
    };

    const onFilterChange =
        (filterName) =>
        (e, { value }) => {
            const updatedState = {
                ...filterState,
                ...utils.validateState(filterState, statsConfig, filterName, value),
            };
            setFilterState(updatedState);
        };

    const { gameTypeId, franchiseId, seasonId, seasonIdForDisplay } = filterState;

    const onFilterSubmit = async (e) => {
        e.preventDefault();

        const updatedState: FilterState = {
            ...filterState,
            seasonIdForDisplay: seasonId,
        };
        setFilterState(updatedState);

        dispatch(leadersActions.requestLeaders(updatedState));

        const deeplinkUrl = `?${utils.getQueryParamsFromState(updatedState, '&')}`;
        window.history.replaceState({}, '', deeplinkUrl);

        setOldFilterState({ ...filterState });

        sendGaEvent('get-stats');
    };

    const isSubmitDisabled =
        franchiseId === oldFilterState.franchiseId &&
        gameTypeId === oldFilterState.gameTypeId &&
        seasonId === oldFilterState.seasonId;

    return (
        <HomeContainer role="tabpanel" id={`${HOME_TITLE}-tabpanel`} aria-labelledby={HOME_TITLE}>
            <Filter
                seasonId={seasonId}
                gameTypeId={gameTypeId}
                franchiseId={franchiseId}
                onFilterChange={onFilterChange}
                onFilterSubmit={onFilterSubmit}
                isSubmitDisabled={isSubmitDisabled}
            />
            <MessageBanner />
            <LeaderContainer seasonIdForDisplay={seasonIdForDisplay} sendGaEvent={sendGaEvent} />
        </HomeContainer>
    );
};

export { Home as Component };
